import Fuse from 'fuse.js';
const THRESHOLD = 0.3;
export const Search = (searchTerm, array, keys) => {
    const fuse = new Fuse(array, {
        threshold: THRESHOLD,
        keys: keys,
    });
    return fuse.search(searchTerm);
};
export const SortType = {
    Asc: 'asc',
    Desc: 'desc',
};
const PACKET_KEYS = ['name', 'code', 'description'];
const Packets = (searchTerm, stretches) => Search(searchTerm, stretches, PACKET_KEYS);
const Stretches = (searchTerm, list) => Search(searchTerm, list, PACKET_KEYS);
export default { Packets, Stretches };



//////////////////
// WEBPACK FOOTER
// ./src/helpers/FuzzySearch.ts
// module id = 107
// module chunks = 0